module.exports = __webpack_public_path__ + "img/nuanyang.c08fa93c.png";